<template>
  <div>
    <section-title has-line title="Información de Pagos" />
    <div class="row mb-3">
      <div class="col">
        <payment-info-filter
          :periods="catalog.periods"
          :regions="catalog.regions"
          :services="catalog.services"
          @on-search="onSearchHandler"
        />
      </div>
    </div>
    <div v-if="showGroupedView" class="row mb-3 pt-3">
      <div class="col">
        <payment-info-grouped-summary :value="groupedSummary" />
      </div>
    </div>
    <div class="row">
      <div
        class="col"
        :class="{
          'hide-tab-header': hideTabs,
          'no-tab-border': showGroupedView,
        }"
      >
        <custom-tab
          v-model="tabIndex"
          class="custom-tab-extended"
          @input="onTabChanged"
        >
          <custom-tab-item active lazy :title="pendingTabTitle">
            <custom-result-not-found v-if="pendingService.data.length == 0" />
            <div
              v-if="showMoveJournal"
              class="d-flex justify-content-between align-items-end my-3"
            >
              <div class="flex-grow-1 mr-3">
                <select-journal-payment
                  v-if="showMoveSelector"
                  :journals="availableJournalsForMove"
                  @on-cancel="onMoveSelectorCancel"
                  @on-confirm="onMoveSelectorConfirm"
                />
              </div>
              <div class="d-flex align-items-center flex-shrink-0">
                <span class="color-green font-16 font-weight-normal pt-1">
                  Seleccionar Todos
                </span>
                <check-box v-model="checkedPending" class="w-auto ml-2" />
              </div>
            </div>
            <div
              v-for="(item, index) in pendingService.data"
              :key="`pending-service-item-${index}`"
              class="my-2"
            >
              <payment-info-row
                :index="index"
                :is-pending-tab="true"
                :journal-status="value.paymentJournalStatusId"
                :journal-type="value.paymentJournalTypeId"
                :value="item"
                @on-denegate-item="onDenegateHandler"
                @on-move-to-journal="onMoveToJournal"
                @on-open-additional-section="onOpenAdditionalSection(0, $event)"
                @on-open-deny-section="onOpenAdditionalSection(0, $event)"
                @on-open-general-additional-section="
                  onOpenGeneralAdditionalSection(0, $event)
                "
              />
              <div
                v-if="item.isNotEligible"
                class="bg-secondary-18 p-2 rounded mt-n3 mb-3"
              >
                <div
                  class="color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                >
                  <em class="fas fa-bell-exclamation pl-1" />
                  <div class="ml-2 no-eligible-message pl-2">
                    El estudiante no es elegible para Becas de Transportación de
                    acuerdo a los PEI’s firmados en el sistema.
                  </div>
                </div>
              </div>
              <div
                v-if="item.notEligiblePayment"
                class="bg-secondary-19 p-2 rounded mt-n3 mb-3"
              >
                <div
                  class="color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                >
                  <em class="fa fa-times-circle color-secondary-20 mr-2" />
                  <div class="color-secondary-20 font-14 font-weight-normal">
                    No es posible aprobar los pagos, ya que cuenta con
                    estudiante(s) no elegible(s) para Becas de Transportación de
                    acuerdo a los PEI’s firmados en el sistema.
                  </div>
                </div>
              </div>
            </div>
            <pagination
              v-if="pendingService.totalItemCount > pageSize"
              :data="pendingService"
              :page-size="pageSize"
              @pagination-go-page="onChangePendingPage"
            />
          </custom-tab-item>
          <custom-tab-item :active="hideTabs" lazy :title="processedTabTitle">
            <template v-if="showGroupedView">
              <custom-result-not-found
                v-if="groupedService.data.length === 0"
              />
              <payment-info-grouped-row
                v-for="(student, index) in groupedService.data"
                :key="`grouped-student-${index}`"
                class="my-2"
                :journal-status="value.paymentJournalStatusId"
                :value="student"
                @on-save-payment-reference="onSavePaymentReference"
                @on-save-voucher="onSaveVoucher"
              />
              <pagination
                v-if="groupedService.totalItemCount > pageSize"
                :data="groupedService"
                :page-size="pageSize"
                @pagination-go-page="onChangeGroupedPage"
              />
            </template>
            <template v-else>
              <custom-result-not-found
                v-if="processedService.data.length == 0"
              />
              <div
                v-if="processedService.data.length > 0"
                class="d-flex justify-content-end align-items-center my-3"
              >
                <span class="color-green font-16 font-weight-normal pt-1">
                  Seleccionar Todos
                </span>
                <check-box v-model="checkedProcessed" class="w-auto ml-2" />
              </div>
              <div
                v-for="(item, index) in processedService.data"
                :key="`processed-service-item-${index}`"
                class="my-2"
              >
                <payment-info-row
                  :index="index"
                  :journal-status="value.paymentJournalStatusId"
                  :value="item"
                  @on-denegate-item="onDenegateHandler"
                  @on-open-additional-section="
                    onOpenAdditionalSection(1, $event)
                  "
                  @on-open-deny-section="onOpenAdditionalSection(1, $event)"
                  @on-open-general-additional-section="
                    onOpenGeneralAdditionalSection(1, $event)
                  "
                />
                <div
                  v-if="item.isNotEligible"
                  class="bg-secondary-18 p-2 rounded mt-n3 mb-3"
                >
                  <div
                    class="color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                  >
                    <em class="fas fa-bell-exclamation pl-1" />
                    <div class="ml-2 no-eligible-message pl-2">
                      El estudiante no es elegible para Becas de Transportación
                      de acuerdo a los PEI’s firmados en el sistema.
                    </div>
                  </div>
                </div>
              </div>
              <pagination
                v-if="processedService.totalItemCount > pageSize"
                :data="processedService"
                :page-size="pageSize"
                @pagination-go-page="onChangeProcessedPage"
              />
            </template>
          </custom-tab-item>
        </custom-tab>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import CheckBox from 'CheckBox';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import PaymentInfoRow from './PaymentInfoRow';
import PaymentInfoFilter from './PaymentInfoFilter';
import PaymentInfoGroupedRow from './PaymentInfoGroupedRow';
import PaymentInfoGroupedSummary from './PaymentInfoGroupedSummary';
import SelectJournalPayment from './SelectJournalPayment';
import {
  getPaymentJournalDetailData as _getPaymentJournalDetailData,
  getPaymentJournalDetailGroupedData as _getPaymentJournalDetailGroupedData,
  getPaymentJournalGroupedSummary as _getPaymentJournalGroupedSummary,
  savePaymentJournalStudentVoucher as _savePaymentJournalStudentVoucher,
  savePaymentJournalStudentPaymentReference as _savePaymentJournalStudentPaymentReference,
  getAvailableJournalsForMove as _getAvailableJournalsForMove,
  moveAssistanceSummaryToJournal as _moveAssistanceSummaryToJournal,
} from '@/modules/shared/scholarship.api.js';
import { getDisciplineTypesSplit as _getDisciplineTypesSplit } from '@/modules/shared/code.api.js';
import { getPeriodsByFiscalYears as _getPeriodsByFiscalYear } from '@/modules/shared/academicyear.api';
import { getRegions as _getRegions } from '@/modules/shared/location.api';
import paymentJournalStatus from '@/utils/constants/paymentJournalStatus';
import paymentJournalType from '@/utils/constants/paymentJournalType';
import alertMixin from 'utils/mixins/alert.mixin';

const DEFAULT_PAGE_SIZE = 15;

export default {
  name: 'PaymentInfo',
  components: {
    SectionTitle,
    Pagination,
    CustomResultNotFound,
    CheckBox,
    CustomTab,
    CustomTabItem,
    PaymentInfoRow,
    PaymentInfoFilter,
    PaymentInfoGroupedRow,
    PaymentInfoGroupedSummary,
    SelectJournalPayment,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    showJournalType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paymentJournalId: null,
      catalog: {
        services: [],
        periods: [],
        regions: [],
      },
      pendingService: {
        data: [],
        totalItemCount: 0,
      },
      processedService: {
        data: [],
        totalItemCount: 0,
      },
      checkedPending: false,
      checkedProcessed: false,
      tabIndex: 0,
      selectedFilter: {},
      groupedService: {
        data: [],
        totalItemCount: 0,
      },
      groupedSummary: {
        totalProcessedPayments: 0,
        totalStudents: 0,
        totalProcessedStudents: 0,
        totalPaidStudents: 0,
      },
      showMoveSelector: false,
      availableJournalsForMove: [],
      rowToMove: null,
    };
  },
  computed: {
    pendingTabTitle() {
      return `Pendientes (${this.pendingService.totalItemCount})`;
    },
    processedTabTitle() {
      return `Procesados (${this.processedService.totalItemCount})`;
    },
    isSIE() {
      return (value) => value?.length <= 8 ?? null;
    },
    isSSN() {
      return (value) => value?.length > 8 ?? null;
    },
    getFilterParams() {
      return {
        serviceId: this.selectedFilter.service?.id,
        monthId: this.selectedFilter.period?.id,
        regionId: this.selectedFilter.region?.id,
        studentSieId: this.isSIE(this.selectedFilter.ssnorsie)
          ? this.selectedFilter.ssnorsie
          : null,
        studentSsn: this.isSSN(this.selectedFilter.ssnorsie)
          ? this.selectedFilter.ssnorsie
          : null,
      };
    },
    isProcessed() {
      return (
        this.value.paymentJournalStatusId === paymentJournalStatus.Procesado
      );
    },
    showGroupedView() {
      return (
        this.showJournalType &&
        [
          paymentJournalStatus.Procesado,
          paymentJournalStatus.EnviadoAFinanzas,
          paymentJournalStatus.Pagado,
        ].includes(this.value.paymentJournalStatusId) &&
        this.value.paymentJournalTypeId === paymentJournalType.ACH
      );
    },
    hideTabs() {
      return this.value.paymentJournalStatusId != paymentJournalStatus.Nuevo;
    },
    pageSize() {
      return DEFAULT_PAGE_SIZE;
    },
    showMoveJournal() {
      return (
        this.showJournalType &&
        this.value.paymentJournalStatusId === paymentJournalStatus.Nuevo &&
        this.pendingService.data.length > 0
      );
    },
  },
  watch: {
    showGroupedView(val) {
      if (val) {
        this.callGroupedPaymentDetail();
        this.callGroupedSummary();
      }
    },
    checkedPending(value) {
      this.pendingService = {
        ...this.pendingService,
        data: this.pendingService.data.map((item) => {
          item.isChecked = value;
          return item;
        }),
      };
    },
    checkedProcessed(value) {
      this.processedService = {
        ...this.processedService,
        data: this.processedService.data.map((item) => {
          item.isChecked = value;
          return item;
        }),
      };
    },
    'pendingService.data': {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.$emit('items-checked', [...this.getCheckedItems()]);
        }
      },
    },
    'processedService.data': {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.$emit('items-checked', [...this.getProcessedCheckedItems()]);
        }
      },
    },
  },
  async mounted() {
    const { academicYearId, paymentJournalId } = this.$route.params;
    if (paymentJournalId) {
      this.paymentJournalId = paymentJournalId;
      await this.callPendingPaymentDetail();
      await this.callProcessedPaymentDetail();
      if (this.showGroupedView) {
        await this.callGroupedPaymentDetail();
        await this.callGroupedSummary();
      }

      if (academicYearId) {
        await this.initFilters(academicYearId);
      }
    }
  },
  methods: {
    onChangePendingPage(page) {
      this.callPendingPaymentDetail(page);
    },
    onChangeProcessedPage(page) {
      this.callProcessedPaymentDetail(page);
    },
    async onSearchHandler(filter) {
      this.selectedFilter = filter;
      if (this.tabIndex === 0) {
        await this.callPendingPaymentDetail();
      } else if (this.showGroupedView) {
        await this.callGroupedPaymentDetail();
      } else {
        await this.callProcessedPaymentDetail();
      }
    },
    getCheckedItems() {
      return this.pendingService.data
        .filter((x) => x.isChecked)
        .map((x) => x.assistanceSummaryId);
    },
    getProcessedCheckedItems() {
      return this.processedService.data
        .filter((x) => x.isChecked)
        .map((x) => x.assistanceSummaryId);
    },
    onTabChanged(tabIndex) {
      this.resetChecked();
      this.$emit('on-tab-changed', tabIndex);
    },
    async callPendingPaymentDetail(pageIndex = 1) {
      this.checkedPending = false;
      this.checkedProcessed = false;

      const { data: response } = await _getPaymentJournalDetailData(
        {
          paymentJournalId: this.paymentJournalId,
          paymentApprovalFlag: '0',
          ...this.getFilterParams,
        },
        pageIndex
      );

      this.pendingService = {
        ...this.pendingService,
        ...response,
        data: response.data.map((x) => ({
          ...x,
          isChecked: false,
          isOpened: false,
          isOpenDenyPayment: false,
        })),
      };
    },
    onChangeGroupedPage(page) {
      this.callGroupedPaymentDetail(page);
    },
    async onSaveVoucher({ item, voucher }) {
      await _savePaymentJournalStudentVoucher({
        paymentJournalId: +this.paymentJournalId,
        studentSieId: item.studentSieId,
        voucherNumber: voucher.voucherNumber,
        voucherDate: voucher.voucherDate,
      })
        .then(async () => {
          this.ShowToast(
            'Proceso Exitoso',
            'Información de Voucher ha sido añadida correctamente',
            'success'
          );
          await this.callGroupedPaymentDetail();
          await this.callGroupedSummary();
        })
        .catch((e) => this.ShowToast('', e?.response?.data?.message, 'error'));
    },
    async onSavePaymentReference({ item, paymentReference }) {
      await _savePaymentJournalStudentPaymentReference({
        paymentJournalId: +this.paymentJournalId,
        studentSieId: item.studentSieId,
        paymentReferenceNumber: paymentReference.paymentReferenceNumber,
        paymentDate: paymentReference.paymentDate,
      })
        .then(async () => {
          this.ShowToast(
            'Proceso Exitoso',
            'Referencia de pago registrada correctamente.',
            'success'
          );
          await this.callGroupedPaymentDetail();
          await this.callGroupedSummary();
        })
        .catch((e) => this.ShowToast('', e?.response?.data?.message, 'error'));
    },
    async onMoveToJournal(item) {
      this.rowToMove = item;
      const { data } = await _getAvailableJournalsForMove(
        this.paymentJournalId
      );
      this.availableJournalsForMove = data ?? [];
      this.showMoveSelector = true;
    },
    onMoveSelectorCancel() {
      this.showMoveSelector = false;
      this.rowToMove = null;
      this.availableJournalsForMove = [];
    },
    async onMoveSelectorConfirm(targetJournalId) {
      const targetJournal = this.availableJournalsForMove.find(
        (j) => j.paymentJournalId === targetJournalId
      );
      const sourceJournalNumber = this.value?.paymentJournalNumber ?? '';
      const targetJournalNumber = targetJournal?.paymentJournalNumber ?? '';
      const studentName = this.rowToMove?.studentFullName ?? '';

      const answer = await this.ShowCancelModal(
        'Confirmar movimiento',
        `¿Desea mover al estudiante ${studentName} del jornal ${sourceJournalNumber} al jornal ${targetJournalNumber}?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      await _moveAssistanceSummaryToJournal(
        this.rowToMove.assistanceSummaryId,
        targetJournalId
      )
        .then(async () => {
          this.ShowToast(
            'Proceso Exitoso',
            'El registro fue movido exitosamente.',
            'success'
          );
          this.onMoveSelectorCancel();
          await this.callPendingPaymentDetail();
        })
        .catch((e) => this.ShowToast('', e?.response?.data?.message, 'error'));
    },
    async callGroupedSummary() {
      const { data } = await _getPaymentJournalGroupedSummary(
        this.paymentJournalId
      );
      this.groupedSummary = data;
      this.$emit('grouped-summary-updated', data);
    },
    async callGroupedPaymentDetail(pageIndex = 1) {
      const { data: response } = await _getPaymentJournalDetailGroupedData(
        {
          paymentJournalId: this.paymentJournalId,
          paymentApprovalFlag: '1',
          ...this.getFilterParams,
        },
        pageIndex
      );

      this.groupedService = {
        ...this.groupedService,
        totalItemCount: response.totalItemCount,
        pageCount: response.pageCount,
        data: response.data,
      };
    },
    async callProcessedPaymentDetail(pageIndex = 1) {
      const { data: response } = await _getPaymentJournalDetailData(
        {
          paymentJournalId: this.paymentJournalId,
          paymentApprovalFlag: '1',
          ...this.getFilterParams,
        },
        pageIndex
      );

      this.processedService = {
        ...this.processedService,
        ...response,
        data: response.data.map((x) => ({
          ...x,
          isChecked: false,
          isOpened: false,
          isOpenDenyPayment: false,
        })),
      };
    },
    async initFilters(academicYearId) {
      const { data } = await _getPeriodsByFiscalYear(academicYearId);
      this.catalog.periods = data;

      const { data: responseServices } = await _getDisciplineTypesSplit();
      this.catalog.services = responseServices;

      let parameters = {
        academicYearId: academicYearId,
      };
      const { data: responseRegions } = await _getRegions(parameters);
      this.catalog.regions = responseRegions;
    },
    resetChecked() {
      this.checkedPending = false;
      this.checkedProcessed = false;

      this.pendingService = {
        ...this.pendingService,
        data: this.pendingService.data.map((item) => {
          item.isChecked = false;
          item.isOpened = false;
          item.isOpenDenyPayment = false;
          return item;
        }),
      };
      this.processedService = {
        ...this.processedService,
        data: this.processedService.data.map((item) => {
          item.isChecked = false;
          item.isOpened = false;
          item.isOpenDenyPayment = false;
          return item;
        }),
      };
    },
    async onDenegateHandler(assistanceSummaryId, comment) {
      this.$emit('on-denegate-item', assistanceSummaryId, comment);
    },
    onOpenAdditionalSection(tabIndex, { itemIndex, propName }) {
      if (tabIndex === 0) {
        this.pendingService = {
          ...this.pendingService,
          data: this.pendingService.data.map((item, index) => {
            if (itemIndex == index) {
              item[propName] = !item[propName];
            } else {
              item[propName] = false;
              item.isOpened = false;
            }
            return item;
          }),
        };
      } else {
        this.processedService = {
          ...this.processedService,
          data: this.processedService.data.map((item, index) => {
            if (itemIndex == index) {
              item[propName] = !item[propName];
            } else {
              item[propName] = false;
              item.isOpened = false;
            }
            return item;
          }),
        };
      }
    },
    onOpenGeneralAdditionalSection(tabIndex, { itemIndex, generalTabIndex }) {
      if (tabIndex === 0) {
        this.pendingService = {
          ...this.pendingService,
          data: this.pendingService.data.map((item, index) => {
            if (itemIndex == index) {
              item.mainTabModel = generalTabIndex;
              item.isOpened = true;
            } else {
              item.isOpened = false;
            }
            return item;
          }),
        };
      } else {
        this.processedService = {
          ...this.processedService,
          data: this.processedService.data.map((item, index) => {
            if (itemIndex == index) {
              item.mainTabModel = generalTabIndex;
              item.isOpened = true;
            } else {
              item.isOpened = false;
            }
            return item;
          }),
        };
      }
    },
    validateEliglePayments() {
      this.setNotEligiblePayments();
      return this.pendingService.data.some(
        (s) => s.isChecked && s.isNotEligible
      );
    },
    setNotEligiblePayments() {
      this.pendingService = {
        data: this.pendingService.data.map((x) => {
          x.notEligiblePayment = x.isChecked && x.isNotEligible;
          return x;
        }),
      };
    },
  },
};
</script>

<style scoped lang="scss">
.no-tab-border {
  ::v-deep .custom-tab-container {
    border-bottom: none !important;
  }
}

::v-deep .hide-tab-header {
  .nav-item {
    display: none !important;
  }
}

@media only screen and (max-width: 768px) {
  .hide-tab-header {
    ::v-deep .custom-tab-extended {
      .nav-item,
      .nav-left-icon,
      .nav-right-icon {
        display: none !important;
      }
    }
  }
}
</style>
